// extracted by mini-css-extract-plugin
export default {"toast":"app_toast__F9XYv"};